<ion-content>
  <ion-grid>
    @for (varinstance of instances; track varinstance) {
      <ion-row class="ion-justify-content-center">
        <ion-col size="12" size-xl="8">
          <ion-card>
            <form [formGroup]="varinstance.form" (ngSubmit)="submit(varinstance)">
              <ion-item lines="full" color="primary">
                <ion-label>{{ appName }}</ion-label>
              </ion-item>
              <ion-card-content>
                <formly-form [form]="varinstance.form" [fields]="varinstance.fields" [model]="varinstance.properties">
                </formly-form>
                <ion-item>
                  <ion-button type="submit" color="primary"
                    [disabled]="(!((!varinstance.form.pristine) && (varinstance.form.valid))) || varinstance.isDeleting || varinstance.isUpdating"
                    translate> EDGE.CONFIG.APP.UPDATE_APP
                  </ion-button>
                  <ion-button (click)="submitDelete(varinstance)" color="primary"
                    [disabled]="varinstance.isDeleting || varinstance.isUpdating" translate>
                    EDGE.CONFIG.APP.DELETE_APP
                  </ion-button>
                  @if (varinstance.isDeleting || varinstance.isUpdating) {
                    <div style="min-height: 100px;">
                    </div>
                  }
                  <ngx-spinner [name]="varinstance.instanceId"></ngx-spinner>
                </ion-item>
              </ion-card-content>
            </form>
          </ion-card>
        </ion-col>
      </ion-row>
    }
  </ion-grid>
</ion-content>
